'use client';

import { useLayoutEffect } from 'react';
import { useGlobalLoader } from '@/providers/LoadingProvider';
import { isAutoLoginFlow } from '@/lib/utils/auth';
import { isPreAuthLandingEntry } from '@/lib/utils/loginAuthCallback';
import { isAppleLogin, isFacebookLogin, isOTPLogin } from '@/lib/utils/loginFlow';
import {
    hasLatchedLoginLoaderBackground,
    latchLoginLoaderBackground,
    releaseLoginLoaderHandoff,
} from '@/components/StoreLoadingCover/loginLoaderBackgroundSession';
import { setLoginLoaderBgMode } from '@/components/StoreLoadingCover/StoreLoadingCover.utils';
import { getLoginLoaderBackgroundStyle } from '@/lib/utils/style';
import { featureFlagService } from '@/lib/services/featureFlag';
import { FeatureFlags } from '@/lib/consts/featureFlags';
import { useAuthBoot } from '../context/AuthBootContext';

export function LoginLoaderInitializer(): null {
    const { authBoot } = useAuthBoot();
    const { showLoader, hideLoader } = useGlobalLoader();

    useLayoutEffect(() => {
        const isPreAuthLanding = isPreAuthLandingEntry(
            new URLSearchParams(window.location.search),
            featureFlagService.isEnabled(FeatureFlags.CHECKOUT_LINKS_USE_DYNAMO_JWT),
        );
        const inActiveLoginFlow =
            isAutoLoginFlow()
            || isAppleLogin()
            || isFacebookLogin()
            || isOTPLogin();

        if (isPreAuthLanding) {
            latchLoginLoaderBackground(getLoginLoaderBackgroundStyle(authBoot));
        } else if (!inActiveLoginFlow && hasLatchedLoginLoaderBackground()) {
            // A failed portal handoff (or /login revisited after /failed) can
            // leave art in sessionStorage; only /shop dismissal should keep it.
            releaseLoginLoaderHandoff();
            setLoginLoaderBgMode(false);
        }

        if (inActiveLoginFlow) {
            showLoader();
        } else {
            hideLoader();
        }
    }, [authBoot, hideLoader, showLoader]);

    return null;
}
